var generateStyle = function generateStyle(componentTheme) {
  return {
    /* Hide left header when the RCE editor is in fullscreen mode */
    globalStyles: {
      'body.tox-fullscreen .leftHeader': {
        display: 'none'
      }
    },
    header: {
      backgroundColor: componentTheme.headerBackgroundColor,
      color: componentTheme.headerColor
    },
    dividingLine: {
      width: '0',
      borderLeft: componentTheme.dividingLineLeftBorder
    }
  };
};
export default generateStyle;